import { PeopleAltOutlined } from '@material-ui/icons';
import { GetRoutesConfig, RoutesMaps } from '../common/routes-map-model';

const route = 'volunteering';

export const getGeneralRoutesMap = ({ userIdentityService, configItems, org }: GetRoutesConfig): RoutesMaps => {
  // Default to true if org data is not available yet
  const packageConfig = org?.packageConfig;
  
  return {
  route,
  heading: 'Volunteering',
  Icon: PeopleAltOutlined,
  isAuthorized: userIdentityService.isVolunteer,
  hidden: packageConfig ? !packageConfig.rostering : false,
  items: [
    {
      label: 'Activities',
      route: 'activities',
      isAuthorized: true,
      hidden: packageConfig ? !packageConfig.rostering : false,
    },
    {
      label: 'Activity Report',
      route: 'activity-report',
      isAuthorized: configItems.vm.preventVolunteerReports 
                   ? (userIdentityService.isActivityLeader || 
                      userIdentityService.isProgramManager || 
                      userIdentityService.isVmAdmin)
                   : true,
      hidden: packageConfig ? !packageConfig.rostering : false,
    },
    {
      label: 'Incident Report',
      route: 'incident-report',
      isAuthorized: true,
      hidden: packageConfig ? !packageConfig.incidents : false,
    },
  ],
  };
};
